export const INTERVIEW_MOBILE_BREAKPOINT_PX = 768;

export type InterviewLayoutMode = "desktop" | "mobile";
export type InterviewLayoutOverride = InterviewLayoutMode | "auto";

function normalizeLayoutValue(value: string | null): InterviewLayoutOverride {
  switch (value?.trim().toLowerCase()) {
    case "desktop":
    case "pc":
      return "desktop";
    case "mobile":
    case "phone":
      return "mobile";
    default:
      return "auto";
  }
}

export function parseInterviewLayoutOverride(
  search: string | URLSearchParams
): InterviewLayoutOverride {
  const params =
    typeof search === "string"
      ? new URLSearchParams(search.startsWith("?") ? search.slice(1) : search)
      : search;
  return normalizeLayoutValue(params.get("layout") ?? params.get("interviewLayout"));
}

export function resolveInterviewLayoutMode({
  isMobileViewport,
  search = "",
}: {
  isMobileViewport: boolean;
  search?: string | URLSearchParams;
}): InterviewLayoutMode {
  const override = parseInterviewLayoutOverride(search);
  if (override !== "auto") return override;
  return isMobileViewport ? "mobile" : "desktop";
}
